/*
 *
 * OperationCurrency
 *
 * @version 1.0.0
 * @author Andrea Esposito
 * @since 26-May-2026
 */

import React from 'react'
import PropTypes from 'prop-types'
// import { useIntl } from 'react-intl'
import { timezoneDateConverter } from 'Utility/dateMethods'
import { formatFiscalAmount } from 'Utility/numberMethods'
import PortalTextBlocked from 'Components/PortalTextBlocked'
import formattedMessage from './languageModule'
import './OperationCurrency.scss'


const OperationCurrency = ({ info, isLoading }) => {
  // const intl = useIntl()

  const additionalData = info?.additionalData
  const conversionRateValue =
    additionalData?.merchantCurrency &&
    additionalData?.conversionRate &&
    info?.operationCurrency &&
    `${formatFiscalAmount('1', additionalData?.merchantCurrency, true, 0)} = ${formatFiscalAmount(
      additionalData?.conversionRate,
      info?.operationCurrency,
      true,
      4,
      { scale: false, roundingMode: 'trunc' }
    )}`

  const fields = {
    operationamount:
      (info?.operationAmount &&
        info?.operationCurrency &&
        formatFiscalAmount(info?.operationAmount, info?.operationCurrency)) ||
      '-',
    merchantamount:
      (additionalData?.merchantAmount &&
        additionalData?.merchantCurrency &&
        formatFiscalAmount(additionalData?.merchantAmount, additionalData?.merchantCurrency)) ||
      '-',
    conversionrate: conversionRateValue || '-',
    conversionratedate:
      (additionalData?.conversionRateDate && timezoneDateConverter(additionalData?.conversionRateDate, true)) || '-'
  }

  return (
    <div className='text_field_section operation_currency_fields'>
      {fields &&
        Object.entries(fields).map(([field, value]) => (
          <PortalTextBlocked
            key={`operation-currency-info-field-${field}`}
            label={formattedMessage[field]}
            value={value || '-'}
            isLoading={isLoading}
            noPadding
          />
        ))}
    </div>
  )
}

OperationCurrency.propTypes = {
  // Add here some propTypes
  // and set a minimal description i.e.
  /** Description of prop "baz". */
  info: PropTypes.object,
  isLoading: PropTypes.bool
}

OperationCurrency.defaultProps = {
  // Add here some default propTypes values
  info: {},
  isLoading: false
}

export default OperationCurrency
